module.exports = __webpack_public_path__ + "assets/img/star_sentence6.e6b7fc03.png";